import { Common } from './common';
import { UpdateTrainingSegmentsWorkflowResponse } from './models/trainingSegments';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async transcribingStarted(
    noteId: string,
  ): Promise<UpdateTrainingSegmentsWorkflowResponse> {
    const url = this.common.constructPath(
      `/note/${noteId}/training-segments/transcribing/started`,
    );
    return this.common.postJSON(url, {});
  }

  async transcribingCompleted(
    noteId: string,
  ): Promise<UpdateTrainingSegmentsWorkflowResponse> {
    const url = this.common.constructPath(
      `/note/${noteId}/training-segments/transcribing/completed`,
    );
    return this.common.postJSON(url, {});
  }
}
